module.exports = __webpack_public_path__ + "static/media/roiTestimonialWeb3x.6834dc4c.png";